import React, { useState, useEffect } from "react";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import ReverseService from "../../../services/ReverseService";
import CollectOrderService from "../../../services/CollectOrderService";
import TiposColeta from "../../../enums/TiposColeta";
import SgsService from "../../../services/SgsService";
import DocumentoService from "../../../services/DocumentoService"
import MinorCollectOrderDetails from '../../molecules/MinorCollectOrderDetails';
import RequestService from "../../../services/RequestService";
import DepositService from "../../../services/DepositService";

export default function GenerateGEModal({
  isModalOpen,
  setModalOpen,
  collectOrderId,
  // setTicketCb
}) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm();

  const [collectOrderObject, setCollectOrderObject] = useState();
  const [requestRefObj, setRequestRefObj] = useState()
  const [depositList, setDepositList] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [updated, setUpdated] = useState(false);

  useEffect(() => {
    async function fetchCollectOrder() {
      const cOrder = await CollectOrderService.getCollectOrdersById(
        collectOrderId
      );
      setCollectOrderObject(cOrder);

      
      const deposits = await DepositService.getDeposits();
      setDepositList(deposits)
      
    }

    fetchCollectOrder();

  }, [collectOrderId, isModalOpen, updated]);

  useEffect(() => {
    async function fetchRequest() {
      const requestRef = await RequestService.getRequestById(
        collectOrderObject?.collectOrder?.reverse?.request
      );
      setRequestRefObj(requestRef);
    }
    if (collectOrderObject) fetchRequest();

    if (collectOrderObject?.collectOrder.deposit || collectOrderObject?.collectOrder.reverse) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }

    if (collectOrderObject?.collectOrder.deposit) {
      setValue("deposit", collectOrderObject?.collectOrder.deposit._id);
    } else {
      setValue("deposit", "0");
    }
  }, [collectOrderObject]);


  const onSubmit = async (data) => {

    data = { ...data, status: "ROTA DE COLETA" };

    try {
      await CollectOrderService.updateParcial(collectOrderId, data);
      toast.success("GE Gerada! Pedido em rota de coleta");
    } catch (error) {
      toast.error(error.message);
    }

    setModalOpen(!isModalOpen);
    reset();
  };

  const onClose = () => {
    setModalOpen(!isModalOpen);
    reset();
  };

  const handleDepositChange = async (event) => {
    const selectedDeposit = event.target.value;
    try {
      await CollectOrderService.updateDeposito(collectOrderId, { deposit: selectedDeposit });
      toast.success("Depósito atualizado com sucesso!");
      setIsButtonDisabled(false);
      setUpdated(!updated);
    } catch (error) {
      toast.error("Erro ao atualizar depósito: " + error.message);
    }
  };

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col w-[648px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all mt-6" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col px-4 text-left gap-2 bg-gray-800 rounded-t-lg">
                <div className="text-white text-xl font-bold mt-4">
                  GERAR GUIA DE EXPEDIÇÃO
                </div>
                <div className="flex justify-between">
                  <div className="text-white text-sm px-4">
                    Coleta:{" "}
                    {collectOrderObject?.collectOrder.idCollectOrder}
                  </div>
                  <div className="text-white text-sm px-4">
                    Ref Solicitação:{" "}
                    {/* {collectOrderObject?.collectOrder.idRequest} */}
                    {collectOrderObject?.collectOrder.idRequest ? collectOrderObject?.collectOrder.idRequest : 'AVULSO'}
                  </div>
                </div>
              </div>
              

              <MinorCollectOrderDetails collectOrder={collectOrderObject?.collectOrder} request={requestRefObj?.request} />


              {/* MODAL FORM BEGIN */}

              <div className="flex flex-col mt-6 px-6 text-sm">
                <div className="flex flex-col gap-4 w-full relative text-left">

                  { !collectOrderObject?.collectOrder?.reverse &&
                  <div className="w-full text-xs px-12">
                    <div className="flex flex-col items-start gap-1 w-full">
                      <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                        Deposito Coletor:
                      </label>
                      <select
                        defaultValue="0"
                        {...register("deposit", {
                          validate: (value) => {
                            return value !== "0";
                          },
                        })}
                        onChange={handleDepositChange}
                        className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                  ${errors?.deposit?.type === "validate"
                            ? " border border-red-500 outline-none ring-0"
                            : "border border-zinc-500 outline-none ring-0"
                          }
                                  `}
                      >
                        <option value="0" disabled>
                          Escolha um Depósito
                        </option>
                        {depositList?.deposits?.map((deposit) => (
                          <option key={deposit._id} value={deposit._id}>
                            {deposit.sigla} - {deposit.cidade}
                          </option>
                        ))}
                      </select>
                      {errors?.deposit?.type === "validate" && (
                        <p className="text-red-500 text-xs whitespace-nowrap">
                          Depósito é obrigatório
                        </p>
                      )}
                    </div>
                  </div>
                  }

                  <button
                      disabled={isButtonDisabled}
                      // onClick={() => handleSubmit(onSubmit)()}
                      onClick={() => { DocumentoService.baixarGuiaExpedicao(collectOrderId) }}
                      className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 disabled:bg-gray-400 disabled:cursor-not-allowed"
                    >
                      Gerar Guia de Expedição
                    </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

